import React from 'react';
import PropTypes from 'prop-types';
import classnames from 'classnames';
import { get } from 'lodash-es';
import { CmsEntities } from 'client/data/models/cms';
import { SOURCES, getValidImageUrl } from 'client/utils/image-helpers';
import { ContentCollapse } from 'site-modules/shared/components/content-collapse/content-collapse';
import { SCROLL_OFFSET, SCROLL_DURATION } from 'site-modules/shared/constants/sub-navigation';
import { ContentFragment } from 'site-modules/shared/components/content-fragment/content-fragment';
import { Image } from 'site-modules/shared/components/image/image';
import { Link } from 'site-modules/shared/components/link/link';
import { Element } from 'react-scroll'; // eslint-disable-line no-restricted-syntax

import './more-info-section.scss';

export function MoreInfoSection({ className = '', content, authorContent }) {
  const entry = content.child('html');
  const title = get(entry, 'title');
  if (!title) return null;
  const subTitle = content.subtitle;
  const text = get(entry, 'content');
  const { authorTitle, authorName, photoPath } = authorContent.child('author-info').getAllMetadata();

  return (
    <div className={classnames('mb-1 text-gray-darker more-info', className)}>
      <ContentCollapse
        textClosed="Read more"
        textOpen="Read less"
        justify="justify-content-start"
        btnContainerClasses="mt-0_5 pt-0 pb-0_5"
        btnClasses="px-0_5 py-0 size-16 text-primary-darker more-info-btn"
        btnTextClasses="fw-normal"
        minHeight="304px"
        showBtnBelow
        isEclipseFade={false}
        resetParams={{
          offset: SCROLL_OFFSET,
          duration: SCROLL_DURATION,
          to: 'scrollTop-more-about',
        }}
      >
        <Element id={'scrollTop-more-about'} />
        <ContentFragment classes="title heading-3 pb-1" componentToUse="h2">
          {title}
        </ContentFragment>
        <div className="d-flex pb-0_5 align-items-center">
          {photoPath && (
            <Image
              className="rounded me-1 author-photo"
              imageId={getValidImageUrl(photoPath, SOURCES.STATIC)}
              alt=""
              lazy
              source={SOURCES.STATIC}
            />
          )}
          <div>
            <ContentFragment classes="subtitle heading-4" componentToUse="h3">
              {subTitle}
            </ContentFragment>
            <div className="text-gray-dark small">
              by {authorName}, {authorTitle}
            </div>
          </div>
        </div>
        <ContentFragment>{text}</ContentFragment>
        <Link to="/new-cars-for-sale/" className="d-block mb-1_5">
          Check out new cars, trucks and SUVs for sale here.
        </Link>
      </ContentCollapse>
    </div>
  );
}

MoreInfoSection.propTypes = {
  className: PropTypes.string,
  content: CmsEntities.Content.isRequired,
  authorContent: CmsEntities.Content.isRequired,
};
